import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://media-manager-c.questera.ai/greta-media/199587cac76451c8a0c81fe29a304b4dfef859bf4c50d3d87f3dadd96dddc39882a7b9b97ef41b50b9892514b6d5ef47/images/aW1hZ2UvcG5n/fb2dd0bcc2bb3890a66287fae4bd7f31.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] pt-16 pb-8 border-t border-white/5 relative z-10 pb-28 md:pb-8">
      <div className="container mx-auto px-5">
        <div className="grid md:grid-cols-4 gap-10 md:gap-12 mb-12">
          
          <div className="md:col-span-2">
            <div className="mb-6">
              <img src={LOGO_URL} alt="MAAICH Sgomberi" className="h-12 w-auto object-contain mix-blend-lighten opacity-80" loading="lazy" />
            </div>
            <p className="font-display uppercase italic text-white/50 mb-4">Liberiamo spazi, miglioriamo ambienti.</p>
            <p className="text-sm text-white/40 font-body max-w-sm">
              Servizio premium di sgombero con valutazione dell'usato. Trasformiamo quello che per te è un peso in un vantaggio economico.
            </p>
            <p className="text-[10px] text-white/30 uppercase tracking-widest mt-6">
              MAAICH Sgomberi — Limbiate (MB) <br />
              {/* P.IVA: IT00000000000 (Predisposto per inserimento) */}
            </p>
          </div>

          <div>
            <h4 className="font-display uppercase text-white mb-4">Contatti Diretti</h4>
            <ul className="space-y-4 text-sm text-white/60 font-body">
              <li>
                <span className="block text-white/40 text-xs uppercase mb-1">WhatsApp (Info & Foto)</span>
                <a href="https://wa.me/393921037894?text=Ciao%2C%20vorrei%20un%20preventivo%20gratuito%20per%20uno%20sgombero.%20Posso%20inviarvi%20le%20foto%3F" className="text-white hover:text-maaich-lime transition-colors font-medium">392 103 7894</a>
              </li>
              <li>
                <span className="block text-white/40 text-xs uppercase mb-1">Chiamate</span>
                <a href="tel:+393516488306" className="text-white hover:text-maaich-lime transition-colors font-medium">351 648 8306</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase text-white mb-4">Legale</h4>
            <ul className="space-y-3 text-sm text-white/60 font-body">
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-white transition-colors">Cookie Policy</Link></li>
              <li>
                <button 
                  onClick={() => window.openCookieBanner && window.openCookieBanner()}
                  className="hover:text-white transition-colors text-left"
                >
                  Gestisci cookie
                </button>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/30 font-body text-center md:text-left">
          <p>&copy; {currentYear} MAAICH Sgomberi. Tutti i diritti riservati.</p>
          <p>Operativi in tutta la Lombardia nord - Sede: Limbiate</p>
        </div>
      </div>
    </footer>
  );
}